module.exports = __webpack_public_path__ + "img/mobile-logo.0d8865b6.png";